import { Button as BaseButton } from "@base-ui/react/button";
import { Link } from "react-router-dom";
import { type ReactNode } from "react";
import styles from "./Button.module.css";
// @ts-expect-error pure js
import { classnames } from "../../utils";

type ButtonVariant = "primary" | "secondary" | "tertiary";

interface ButtonLinkProps {
  to: string;
  children: ReactNode;
  variant?: ButtonVariant;
  className?: string;
}

export default function ButtonLink({
  to,
  children,
  variant = "primary",
  className,
}: ButtonLinkProps) {
  return (
    <BaseButton
      className={classnames(styles.button, styles[variant], className)}
      render={<Link to={to} />}
    >
      {children}
    </BaseButton>
  );
}
